import { useState, useEffect } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { GALLERY } from "../data/site";

export default function Gallery() {
  const [active, setActive] = useState(null);

  useEffect(() => {
    const onKey = (e) => {
      if (active === null) return;
      if (e.key === "Escape") setActive(null);
      if (e.key === "ArrowRight") setActive((i) => (i + 1) % GALLERY.length);
      if (e.key === "ArrowLeft") setActive((i) => (i - 1 + GALLERY.length) % GALLERY.length);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [active]);

  return (
    <div data-testid="gallery-page">
      <section className="bg-[#0A192F] text-white py-20 md:py-24">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <div className="flex items-center gap-3 mb-4">
            <span className="slash-divider"></span>
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#0EA5E9]">Gallery</span>
          </div>
          <h1 className="font-head font-black text-4xl md:text-6xl leading-[0.95] tracking-tight max-w-3xl">
            Inside our warehouse &amp; the field.
          </h1>
          <p className="mt-5 text-white/70 max-w-2xl text-lg">
            A glimpse of stocked spares, plant installations and the heavy industry we support.
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
            {GALLERY.map((src, i) => (
              <button
                key={src}
                onClick={() => setActive(i)}
                className="group relative aspect-square overflow-hidden bg-[#F1F5F9]"
                data-testid={`gallery-item-${i}`}
                aria-label={`Gallery image ${i + 1}`}
              >
                <img
                  src={src}
                  alt={`Gallery ${i + 1}`}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover zoom-img"
                />
                <div className="absolute inset-0 bg-[#0A192F]/0 group-hover:bg-[#0A192F]/30 transition-colors" />
              </button>
            ))}
          </div>
        </div>
      </section>

      {active !== null && (
        <div
          className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4"
          onClick={() => setActive(null)}
          data-testid="lightbox"
        >
          <button
            className="absolute top-4 right-4 text-white p-2"
            onClick={(e) => { e.stopPropagation(); setActive(null); }}
            aria-label="Close"
            data-testid="lightbox-close"
          >
            <X size={28} />
          </button>
          <button
            className="absolute left-4 text-white p-2"
            onClick={(e) => { e.stopPropagation(); setActive((i) => (i - 1 + GALLERY.length) % GALLERY.length); }}
            aria-label="Previous"
          >
            <ChevronLeft size={32} />
          </button>
          <img
            src={GALLERY[active]}
            alt=""
            className="max-h-[88vh] max-w-[92vw] object-contain"
            onClick={(e) => e.stopPropagation()}
          />
          <button
            className="absolute right-4 text-white p-2"
            onClick={(e) => { e.stopPropagation(); setActive((i) => (i + 1) % GALLERY.length); }}
            aria-label="Next"
          >
            <ChevronRight size={32} />
          </button>
          <div className="absolute bottom-5 left-0 right-0 text-center text-white/60 text-xs uppercase tracking-[0.2em]">
            {active + 1} / {GALLERY.length}
          </div>
        </div>
      )}
    </div>
  );
}
